module.exports = {
  "log": {
    'logPage':'登陆日志管理',
    'logList':'日志列表',
    'loginName':'登陆名称',
    'status':'状态',
    'ip':'IP地址',
    'msg':'登陆结果',
    'date':'时间',
    'pInput_1':'请输入登陆名称',
    'pInput_2':'请输入IP地址',
    'pInput_3':'请输入功能模块名',
    'pInput_4':'请输入用户名称',
    'tip_1':'删除该记录将不可恢复，确定吗？',
    'date_com1':'至',
    'date_com2':'开始日期',
    'date_com3':'结束日期',
    'logOperation':'操作日志管理',
    'content':'内容',
    "operUrl":'地址',
    'operName':'用户',
    'moudel':'功能模块'
  },
};



// WEBPACK FOOTER //
// ./src/i18n/log/zh-CN.js